import {
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
	Input,
} from "@st-marketplace/ui";
import type { Control, FieldValues, Path } from "react-hook-form";

type OrderRangeFieldsProps<TFieldValues extends FieldValues> = {
	control: Control<TFieldValues>;
	fromName: Path<TFieldValues>;
	toName: Path<TFieldValues>;
	fromLabel: string;
	toLabel: string;
	unitLabel?: string;
	disabled?: boolean;
	gap?: number;
};

export function SettingsOrderRangeFields<TFieldValues extends FieldValues>({
	control,
	fromName,
	toName,
	fromLabel,
	toLabel,
	unitLabel,
	disabled,
	gap = 5,
}: OrderRangeFieldsProps<TFieldValues>) {
	const suffix = unitLabel ? <span>{unitLabel}</span> : undefined;

	return (
		<div className="flex flex-col sm:flex-row" style={{ gap: gap * 8 }}>
			<div className="w-full">
				<FormField
					control={control}
					name={fromName}
					render={({ field }) => (
						<FormItem>
							<FormLabel>{fromLabel}</FormLabel>
							<FormControl>
								<Input
									type="number"
									placeholder={fromLabel}
									value={(field.value as number | null) ?? ""}
									onChange={field.onChange}
									disabled={disabled}
									suffix={suffix}
								/>
							</FormControl>
							<FormMessage />
						</FormItem>
					)}
				/>
			</div>

			<div className="w-full">
				<FormField
					control={control}
					name={toName}
					render={({ field }) => (
						<FormItem>
							<FormLabel>{toLabel}</FormLabel>
							<FormControl>
								<Input
									type="number"
									placeholder={toLabel}
									value={(field.value as number | null) ?? ""}
									onChange={field.onChange}
									disabled={disabled}
									suffix={suffix}
								/>
							</FormControl>
							<FormMessage />
						</FormItem>
					)}
				/>
			</div>
		</div>
	);
}
